jQuery(window).on("scroll resize", function () {
  if (jQuery('body').find('.track').length) {
    var deskTop = jQuery(window).width();
    if (deskTop > 767) {
      jQuery(".ingredients-scroll").css("opacity", "0.25");
      jQuery(".ingredients-scroll").eq(0).css("opacity", "1");
      var scrollTop = jQuery(window).scrollTop();
      var cameraTop = jQuery(".track.wf-section").offset().top;
      if (cameraTop < scrollTop + 200) {
        var translateX = cameraTop - scrollTop;
        var finalTranslateX = Math.min(0, translateX);
        jQuery(".frame").css({
          transform: "translateX(" + finalTranslateX + "px)",
        });
  
        if (scrollTop - cameraTop > 225) {
          var FirstSlide = Math.min(
            Math.max(1 - (scrollTop - cameraTop) / 800, 0.25),
            1
          );
          jQuery(".ingredients-scroll").eq(0).css("opacity", FirstSlide);
          var SecondSlide = Math.min(
            Math.max((scrollTop - cameraTop) / 800, 0.25),
            1
          );
          jQuery(".ingredients-scroll").eq(1).css("opacity", SecondSlide);
        }
        if (scrollTop - cameraTop > 950) {
          var SecondSlide = Math.min(
            Math.max(2 - (scrollTop - cameraTop) / 800, 0.25),
            1
          );
          jQuery(".ingredients-scroll").eq(1).css("opacity", SecondSlide);
          var ThirdSlide = Math.min(
            Math.max((scrollTop - cameraTop) / 800 - 1, 0.25),
            1
          );
          jQuery(".ingredients-scroll").eq(2).css("opacity", ThirdSlide);
        }
        if (scrollTop - cameraTop > 1650) {
          var LastSlide = Math.min(
            Math.max(3 - (scrollTop - cameraTop) / 600, 0),
            1
          );
          jQuery(".frame").css("opacity", LastSlide);
        } else {
          jQuery(".frame").css("opacity", "");
        }
      }
    } else {
      jQuery(".frame").removeAttr("style");
    }
  }
});
jQuery(window).on("scroll resize", function () {
  if (jQuery('body').find('.track').length) {
    var deskTop = jQuery(window).width();
    if (deskTop > 767) {
      var scrollTop = jQuery(window).scrollTop();
      var cameraTop = jQuery(".track.wf-section").offset().top;
      var windowHeight = jQuery(window).height();
      var TopHalf = (50 * windowHeight) / 100;
      if (cameraTop < scrollTop + TopHalf) {
        var TitleOpacity = 1 - (scrollTop + TopHalf - cameraTop) / 500;
        TitleOpacity = Math.min(Math.max(TitleOpacity, 0), 1);
        jQuery(".cameraTitle").css("opacity", TitleOpacity);
      }
    } else {
      jQuery(".cameraTitle").removeAttr("style");
    }
  }
});

// Parallax Image Start
jQuery(window).scroll(function(){
  if (jQuery('body').find('.parallax_image').length) {
    var scroll = jQuery(window).scrollTop();
    var windowHeight = jQuery(window).height();
    jQuery('.parallax_image').each(function(){
      var imageoTop = jQuery(this).offset().top;
      if ( scroll + windowHeight > imageoTop ) {
        var translate = ((scroll + windowHeight) - imageoTop) / 5;
        jQuery(this).find('.image-section__image img').css('transform', 'translateY(' + translate + 'px)');
      }
    });
  }
});
// Parallax Image End